export const PACKAGE_NAME = 'jiraGrowthFeatureGatesTmpAccess';
export const TEAM_NAME = 'growth-tako';
export const LEARN_MORE_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/manage-how-people-access-your-team-managed-project/';

export const FEATURE_GATE_ACTION_SUBJECT = 'featureGate';
export const FEATURE_GATE_UPGRADE_ACTION_SUBJECT = 'featureGateUpgrade';
export const FEATURE_GATE_LEARN_MORE_ACTION_SUBJECT = 'featureGateLearnMore';
export const ACCESS_BANNER_TOUCHPOINT_ID = 'tmpAccessBanner';
export const USER_ROLES_PICKER_TOUCHPOINT_ID = 'tmpAccessUserRolePicker';
